/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto } from '../models/Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto';
import type { Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto';
import type { Wealthlane_AwardService_Dtos_Transactions_ExternalTransactionImportData } from '../models/Wealthlane_AwardService_Dtos_Transactions_ExternalTransactionImportData';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExternalTransactionImportService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppExternalTransactionImportDownloadExternalTransactionImportSample(): CancelablePromise<Wealthlane_AwardService_Dtos_Common_SampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/external-transaction-import/download-external-transaction-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppExternalTransactionImportImportExternalTransaction(
        formData?: {
            File: Blob;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/external-transaction-import/import-external-transaction',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppExternalTransactionImportProcessExternalTransactionImport(
        requestBody?: Array<Wealthlane_AwardService_Dtos_Transactions_ExternalTransactionImportData>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/external-transaction-import/process-external-transaction-import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppExternalTransactionImportImportTest(
        formData?: {
            File: Blob;
        },
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Common_BackgroundValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/external-transaction-import/import-test',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
